/**
 * Resolves a query param, preferring the actual browser URL over the Next.js router query.
 * The page HTML (and so router.query) can be served by the service worker for another URL
 * (offline or slow network), while window.location always reflects what the user opened.
 * On the server it falls back to the router query.
 */
export const resolveQueryParam = (valueFromQuery, key) => {
  if (typeof window !== 'undefined') {
    const valueFromUrl = new URLSearchParams(window.location.search).get(key)
    if (valueFromUrl) return valueFromUrl
  }
  if (typeof valueFromQuery === 'string' && valueFromQuery) return valueFromQuery
  return undefined
}
